export function determinateCurrency(
  isSweepstakesEnabled: boolean,
  currency: string
): string {
  return isSweepstakesEnabled ? "" : currency;
}
